import $ from 'jquery';

export const initScroller = () => {
	const scrollerSel = $(".js-scrollerContainer");
	let intervalObj = false;
	const scrollSize = 20;
	const scrollJump = 200;
	const scrollTime = 350;

	if(scrollerSel.length>0){
		scrollerSel.each(function() {
			$(this).before("<div class='scrollerNav scrollerNav--prev js-scrollerPrev'><img src='https://cdn.ontourmedia.io/u2/non_secure/zf2/images/slider-arrow_left.png' ></div>");
			$(this).after("<div class='scrollerNav scrollerNav--next js-scrollerNext'><img src='https://cdn.ontourmedia.io/u2/non_secure/zf2/images/slider-arrow_right.png' ></div>");
		});
		$(".scrollerNav").on("mouseover", function(){
			const scrollContainer=  $(this).closest(".scrollerWrapper").find(".js-scrollerContainer");
			if($(this).hasClass("js-scrollerPrev")){
				scroll(scrollContainer, (-1 * scrollSize));

				intervalObj=  setInterval(function(){
					scroll(scrollContainer, (-1 * scrollSize));
				}, scrollTime);
			}else if($(this).hasClass("js-scrollerNext")){
				scroll(scrollContainer,  scrollSize);

				intervalObj=  setInterval(function(){
					scroll(scrollContainer,scrollSize);
				}, scrollTime);
			}

			//

		});

		$(".scrollerNav").on("click", function(){

			const scrollContainer=  $(this).closest(".scrollerWrapper").find(".js-scrollerContainer");
			if($(this).hasClass("js-scrollerPrev")){
				scroll(scrollContainer, (-1 * scrollJump));
			}else if($(this).hasClass("js-scrollerNext")){
				scroll(scrollContainer,  scrollJump);
			}
		});

		$(".scrollerNav").on("mouseout", function(){
			stopAutoScroll();
		});

		/*$(".scrollerItemLink").on("click", function(){
			$("#miniLB__fixture > #miniLB__popup > .js-lightboxContent > .js-lightboxImage").removeClass("hideItem");
		});*/
	}


	const stopAutoScroll = () => {
		if(intervalObj !== false){
			clearInterval(intervalObj);
			intervalObj= false;
		}
	}

	const scroll = (scrollContainer,scrollVal) => {
		scrollContainer.scrollLeft(scrollContainer.scrollLeft() + scrollVal);
		//const d = new Date();
		//console.log("Scroll still running",d.getTime());
		//console.log("Left is " + scrollContainer.scrollLeft() + "  AND SCROLL WIDTH is " + scrollContainer.innerWidth());
		if ( scrollContainer.scrollLeft() == 0 ){
			stopAutoScroll();
		}else if (scrollContainer.scrollLeft() >= scrollContainer.get(0).scrollWidth -scrollSize){
			//console.log("Left is " + scrollContainer.scrollLeft() + "  AND SCROLL WIDTH is " + scrollContainer.innerWidth());
			stopAutoScroll();
		}
	};
}
